import classes       from "./SeoList.module.scss";
import AccentTitle   from './../AccentTitle/AccentTitle';

import Item          from '../Item/Item';
import Tooltip       from '../../../Tooltip/tooltip';
import BoldTitle     from '../../../Titles/BoldTitle/BoldTitle';
import Image         from '../../../Image/Image';


import control       from "../../../Assets/Img/Src/SecondStep/control.jpg"
import controlWebp   from "../../../Assets/Img/Webp/SecondStep/control.webp"

import control2      from "../../../Assets/Img/Src/SecondStep/control-2.jpg"
import control2Webp  from "../../../Assets/Img/Webp/SecondStep/control-2.webp"

import KPI           from "../../../Assets/Img/Src/SecondStep/KPI-2.jpg"
import KPIWebp       from "../../../Assets/Img/Webp/SecondStep/KPI-2.webp"

import Cards         from "../../../Cards/Cards";


const SeoList = () => {
  return (
    <div className={classes.SeoList}>
      <AccentTitle
        number={"03."}
        title={"SEO"}
        customClass={classes.Title}
      />
      <div className={classes.Body}>
      <div className={classes.ScrollWrap}>
        <Item
          customWrapClass={classes.ItemWrap}
          number={"a."}
          title={"Семантическое ядро"} 
          text={<><span>Приступив к работам по SEO мы понимали, что семантическое ядро, контролируемое прошлыми подрядчиками не дает возможности понимать динамику роста или падения трафика в связи с позициями запросов</span> <span>.Дополнительно к ядру, которое содержало небольшое количество высокочастотных запросов мы разработали семантическое ядро, состоящее из порядка 340 запросов, включающих все товарные группы, находящиеся на сайте. Ежемесячно мы фиксировали динамику по каждому из них.</span></>}
          src={control} srcWebp={controlWebp}
          customClass={classes.Cards}
          
          customTitleClass={classes.CardsTitle}
          customClassText={classes.CustomText}

        />
      </div>
      <div className={classes.ScrollWrap}>
        <Item
          customWrapClass={classes.ItemWrap}
          number={"b."}
          title={"Внутренняя  поисковая оптимизация"} 
          text={<><span>Была проведена оптимизация сайта по чек-листу, содержащему порядка <span>40 основных пунктов.</span>Были собраны рекомендации Яндекса и Google технического характера, которые были внедрены специалистами нашей поддержки.</span>
            
            <span>Внутренняя поисковая оптимизация в полном объеме проводилась 2 раза, в начале работ и при запуске нового сайта. С момента запуска нового сайта, за счет правильной оптимизации в индексе поисковых систем закрепилось  в 2 раза больше страниц, чем было до оптимизации. Процесс закрепления страниц в индексе был очень плавным.</span>
            
            <span>Все работы по SEO-оптимизации и последующие работы по поисковому продвижению были регламентированы и систематизированы, что позволило четко планировать загрузку специалистов, а также повысило прозрачность оказания услуг для Заказчика.</span>
            </>}
          src={control2} srcWebp={control2Webp}
          customClass={classes.Cards}
          
          customTitleClass={classes.CardsTitle}
          customClassText={classes.CustomText}

        />
      </div>
      <div className={classes.ItemText}>
        <div className={classes.Item}>
          <Cards
            number={"с."}
            title={"Внешняя поисковая оптимизация"}
            customClass={classes.Cards}

            customTitleClass={classes.CardsTitle}
            customClassText={classes.CustomText}
          />
          <div className={classes.RightSide}>
            <p className={classes.Text}>Были настроены Вебмастера:
            <span className={classes.TextList}>- Яндекса</span>
            <span className={classes.TextList}>- Google</span>
            <span className={classes.TextList}>- Mail</span>
            <span className={classes.TextList}>- Bing</span>
            </p>
            <p className={classes.Text}>Данные сервисы постоянно отслеживают основные параметры сайта. Некоторые данные можно получить только из них, например данные о количестве страниц в индексе или количество внешних ссылок.</p>
          </div>
        </div>
        <div className={classes.Item}>
            <Cards
              number={"d."}
              title={"Формирование гипотез по развитию сайта на основе аналитики."}
              customClass={classes.Cards}

              customTitleClass={classes.CardsTitle}
              customClassText={classes.CustomText}
            />
            <div className={classes.RightSide + " " + classes.Description}>
              <div className={classes.TopText}>При разработке нового сайта сторонним разработчикам нами было предложено 2 нововведения:</div>
              <p className={classes.Text}>1. Был введен следующий, «дублирующий», принцип работы страниц товаров: если вы переходите на карточку товара со страниц сайта, то открываются они во всплывающем окне. Это позволило увеличить скорость работы карточек товаров. Но при этом у каждой всплывающей карточки есть основная страница, которая отвечает за появление в индексе при запросе конкретного товара.</p>
              <p className={classes.Text}>2. Нами была предложена новая архитектура формирования страниц дилеров       . Этот подход позволил получить еще порядка 230 страниц в индексе, а также трафик на них. Для интернет-магазина с большим количеством SKU – это не много, для сайта-каталога с дорогостоящим товаром – это серьезный рост.</p>
            </div>
          </div>
          <div className={classes.ScrollWrap}>
          <div className={classes.Image  + " " + classes.Graph}>
            <Image src={KPI} srcWebp={KPIWebp}/>
          </div>
        </div>
      </div>
      <div className={classes.ItemText + " " + classes.ItemTextLast}>
      <div className={classes.Item}>
          <Cards
            number={"с."}
            title={"Внешняя поисковая оптимизация"}
            customClass={classes.Cards}

            customTitleClass={classes.CardsTitle}
            customClassText={classes.CustomText}
          />
          <div className={classes.RightSide}>
            <p className={classes.Text}>
              В рамках работ по SEO большую роль играет развитие контента. До наших работ на сайте контент расширялся только в разделе «новости». Анализ основных посадочных страниц под высокочастотные запросы показал, что контент давно устарел и не соответствует оптимальному размеру       . Для повышения позиций по основным запросам нам нужно было обновить контент для всех основных страниц. Чтобы сделать это идеально на каждый ключевой запрос мы собрали все тексты из ТОП10 и рассчитали среднюю плотность ключевых запросов в них. Кроме этого при постановке задачи копирайтеру была использована информация из документа «Инструкция для асеcсоров Google».
            <span className={classes.accent}>Документ, который предназначен для людей, обучающих нейросети Google с целью правильного распознавания и достоверной оценки контента на сайте.</span>
            </p>
            <p className={classes.Text}>Кроме этого в рамках развития ссылочной стратегии мы пришли к схеме размещения пресс-релизов о компании на различных новостных сайтах. В том числе данные пресс-релизы попадали в различные новостные агреггаторы, например, в ленту Google Новостей.
              <span>Данная стратегия позволяла достигать сразу 2х целей – знакомство новых пользователей с новинками компании, а также повышение количества качественных внешних ссылок, что является одним из факторов, влияющих на ранжирование страниц сайта.</span></p>
          </div>
        </div>
      </div>
    </div>
    </div>

  )
}

export default SeoList;